import "./CustomPagination.css"
import { Select, Row, Col, Pagination } from "antd";


const CustomPagination = (props) => {
  const pageSizeOptions = [10, 20, 50, 100];

  const handlePagination = (currentIndex, currentSize) => {
    let setPageIndex = currentIndex;
    if(currentSize !== props.pagination.pageSize) {
      setPageIndex = 1;
    }
    props.OnPagination(setPageIndex, currentSize);
  };

  return (
    <div className="pagination-container">
      <Row justify="end">
        <Col>
          View Per Page
        </Col>

        <Col>
          <Select
            size="small"
            style={{ marginLeft: "10px" }}
            defaultValue={props.pagination.pageSize}
            onChange={(value) => handlePagination(props.pagination.current, Number(value))}
          >
            {pageSizeOptions.map((pageSize) => (
              <Select.Option key={pageSize} value={pageSize}>
                {pageSize}
              </Select.Option >
            ))}
          </Select>
        </Col>

        <Col>
          <Pagination
            size="small"
            onChange={(value) => handlePagination(value, props.pagination.pageSize)}
            showSizeChanger={false}
            defaultCurrent={props.pagination.current}
            current={props.pagination.current}
            total={props.totalCountRow}
            pageSize={props.pagination.pageSize}
          />
        </Col>
      </Row>
    </div>
  )
}

export default CustomPagination;